import { apiGet, apiPost } from './utils';

export type ApplicationStatus =
  | 'not-started'
  | 'more-info'
  | 'pending'
  | 'accept'
  | 'failed'
  | 'auto-denied';

export type ApplicationOutcome = 'accept' | 'failed';

export interface MyApplication {
  status: ApplicationStatus;
  is_assistant: boolean;
  has_survey: boolean;
  first_name: string | null;
  last_name: string | null;
  home_street_1: string | null;
  home_city: string | null;
  home_state: string | null;
  home_zip: string | null;
  home_country: string | null;
}

export interface SurveyAnswers {
  first_name: string;
  last_name: string;
  home_street_1: string;
  home_city: string;
  home_state: string;
  home_zip: string;
  home_country: string;
  resume: string;
  legally_able_to_work: string;
  when_to_use_google_docs: string;
  carnagie_deli_cross_streets: string;
  finding_a_steakhouse: string;
  what_program_for_docx: string;
  theyre: string;
  there: string;
  their: string;
}

export interface Applicant {
  key: string;
  uuid: string;
  name: string;
  email: string;
  home_city: string | null;
  home_state: string | null;
  is_beta: boolean;
}

export interface SampleTask {
  uuid: string;
  key: string;
  date_created: string;
  date_accepted: string | null;
  message: string | null;
  outcome: string | null;
  outcome_notes: string | null;
  likely_outcome: 'pending' | 'failed';
  applicant: Applicant | null;
}

export interface Survey {
  uuid: string;
  date_created: string;
  name: string | null;
  email: string | null;
  resume: string | null;
  legally_able_to_work: string | null;
  auto_denied: boolean;
  their_score: number;
  their_score_max: number;
  aptitude: Record<string, boolean>;
}

export interface ApplicationDetail {
  sample: SampleTask;
  survey: Survey | null;
}

export const jobApplicationApi = {
  async mine(): Promise<MyApplication> {
    return apiGet<MyApplication>('/job-application/mine');
  },

  async submitSurvey(answers: SurveyAnswers): Promise<{ status: ApplicationStatus }> {
    return apiPost<{ status: ApplicationStatus }>('/job-application/survey', { ...answers });
  },

  async submitSample(message: string): Promise<{ status: ApplicationStatus }> {
    return apiPost<{ status: ApplicationStatus }>('/job-application/sample', { message });
  },

  async list(cursor?: string): Promise<{ items: SampleTask[]; cursor: string | null }> {
    return apiGet<{ items: SampleTask[]; cursor: string | null }>(
      '/job-application/list',
      cursor ? { cursor } : undefined,
    );
  },

  async detail(sampleUuid: string): Promise<ApplicationDetail> {
    return apiGet<ApplicationDetail>('/job-application/detail', { sample_uuid: sampleUuid });
  },

  async setOutcome(
    sampleUuid: string,
    outcome: ApplicationOutcome,
    outcomeNotes: string,
  ): Promise<ApplicationDetail> {
    return apiPost<ApplicationDetail>('/job-application/outcome', {
      sample_uuid: sampleUuid,
      outcome,
      outcome_notes: outcomeNotes,
    });
  },
};
